import axios from 'axios';

const version = 'v1';
const basePath = 'marketplace';

export async function getAll() {
  return axios.request({
    url: `/${version}/${basePath}/list`,
    method: 'get',
    params: {
      order_by: 'id',
      order_mode: 'desc',
    },
  });
}

export async function dsvFailedOrders({ marketplace }) {
  return axios.request({
    url: `/${version}/${basePath}/dsv/failed-orders/`,
    method: 'get',
    params: {
      marketplace,
      order_by: 'id',
      order_mode: 'desc',
    },
  });
}

export async function dsvRetryOrder(purchase_number) {
  return axios.request({
    url: `/${version}/${basePath}/dsv/retry-order/`,
    method: 'put',
    params: {
      order_id: purchase_number,
    },
  });
}

export async function dsvCancelOrder(purchase_number) {
  return axios.request({
    url: `/${version}/${basePath}/dsv/cancel-order/`,
    method: 'delete',
    params: {
      order_id: purchase_number,
    },
  });
}
